import React from 'react'
import styled from 'styled-components'
import Image from 'react-bootstrap/Image'
import Card from 'react-bootstrap/Card'
import Award from 'assets/images/auth/award.svg'
const RewardsContanier = styled.div``
const AwardCard = styled(Card)`
  border-radius: 20px;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
`
const AwardImage = styled(Image)`
  width: 5.313em;
  height: 5.313em;
`
const CardBody = styled(Card.Body)`
  line-height: 3.5;
  text-align: center;
`
export default function RewardsContent() {
  return (
    <RewardsContanier className="mt-5">
      <AwardCard className="justify-content-md-center">
        <CardBody>
          <AwardImage src={Award} />
          <h5 className="mt-5">
            Share now & earn more points to win the below prizes
          </h5>
          <h1>1 Point = 1 Saudi Riyal</h1>
          <p>
            You will need to earn 1000 point before you will be able to redeem
            your points
          </p>
        </CardBody>
      </AwardCard>
    </RewardsContanier>
  )
}
